import React from "react";
import SearchIcon from "@mui/icons-material/Search";

const CustomSearchInput = ({ value, onChange }) => {
  return (
    <div
      className="search-input"
      style={{
        display: "flex",
        alignItems: "center",
        height: "auto",
        border: "1px solid #ccc",
        borderRadius: "12px",
        overflow: "hidden",
        backgroundColor: "#f9f9f9",
        marginBottom: "10px",
        margin: "16px 15px",
      }}
    >
      {/* <div
        style={{
          padding: "0 8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "10px",
          color: "#898A8D",
          whiteSpace: "nowrap",
        }}
      >
        Search
      </div> */}

      <input
        type="text"
        value={value}
        className="search-sidebar"
        onChange={onChange}
        placeholder="Search"
        style={{
          width: "100%",
          border: "none",
          outline: "none",
          padding: "0 8px",
          // 16px, not 14px: iOS Safari auto-zooms the whole page on focus when an input's
          // font-size is under 16px. This is an inline style (not a CSS class), so it can't be
          // scoped to Mobile via a media query — bumping it everywhere is a negligible visual
          // change on Desktop/Tablet for a plain unstyled search box.
          fontSize: "16px",
          backgroundColor: "transparent",
          color: "#333",
        }}
      />

      <div
        style={{
          padding: "0 8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "gray",
          cursor: "pointer",
        }}
      >
        <SearchIcon sx={{ color: "gray", fontSize: "18px" }} />
      </div>
    </div>
  );
};

export default CustomSearchInput;
